export default {
    // 商品复制页面
    // indexOptions: indexOptions,
    indexProps: {
        lazy: true,
        lazyLoad(node, resolve) {
            const data = JSON.parse(localStorage.getItem('categorySearch'));
            const { level } = node;
            const list = [];
            data.map((v) => {
                if (level == 0 || level == 1) {
                    if (v.categoryPid == 0) {
                        v['leaf'] = level >= 2;
                        list.push(v);
                    }
                } else if (node.value == v.categoryPid) {
                    v['leaf'] = level >= 2;
                    list.push(v);
                }
                return v;
            });
            resolve(list);
        },
    },
    // 复制页面 运费模板
    freightOptions: [
        {
            value: 0,
            label: '全国包邮',
        },
        {
            value: 5,
            label: '全国统一为5元运费',
        },
        {
            value: 10,
            label: '全国统一为10元运费',
        },
        {
            value: 15,
            label: '全国统一为15元运费',
        },
        {
            value: 20,
            label: '全国统一为20元运费',
        },
        {
            value: 25,
            label: '全国统一为25元运费',
        },
        {
            value: 30,
            label: '全国统一为30元运费',
        },
    ], // 运费模板选项

    // 抖音的运送时间
    deliveryDelayDayOptions: [
        {
            value: 2,
            label: '2天',
        },
        {
            value: 3,
            label: '3天',
        },
        {
            value: 5,
            label: '5天',
        },
        {
            value: 7,
            label: '7天',
        },
        {
            value: 10,
            label: '10天',
        },
        {
            value: 15,
            label: '15天',
        },
    ],
    //   商品单价类型
    productSingerPriceTypeOptions: [
        {
            value: 0,
            label: '促销价',
        },
        {
            value: 1,
            label: '原价',
        },
    ],
    priceOperationTypeOptions: [
        {
            value: 0,
            label: '加',
        },
        {
            value: 1,
            label: '减',
        },
    ],
    comStatus: [
        // 商品状态
        {
            value: 1,
            label: '售卖中',
        },
        {
            value: 2,
            label: '已下架',
        },
        {
            value: 3,
            label: '草稿箱',
        },
        {
            value: 4,
            label: '审核驳回',
        },
    ],
    typeData: [
        {
            value: 0,
            label: '售卖中',
        },
        {
            value: 1,
            label: '仓库中',
        },
        {
            value: 2,
            label: '审核驳回',
        },
        {
            value: 3,
            label: '草稿箱',
        },
    ],
    auditStatus: [
        {
            value: '',
            label: '全部',
        },
        {
            value: '1',
            label: '未提审',
        },
        {
            value: '2',
            label: '审核中',
        },
        {
            value: '3',
            label: '审核通过',
        },
        {
            value: '4',
            label: '审核驳回',
        },
    ],
    PayTypeList: [
        {
            value: 0,
            label: '货到付款',
        },
        {
            value: 1,
            label: '在线支付',
        },
        {
            value: 2,
            label: '在线支付/货到付款',
        },
    ],
    symbolOpn: [
        {
            value: '0',
            label: '加',
        },
        {
            value: '1',
            label: '减',
        },
    ],
    priceProcessingOptions: [
        {
            value: '0',
            label: '不处理',
        },
        {
            value: '1',
            label: '四舍五入取整',
        },
        {
            value: '2',
            label: '向上取整',
        },
        {
            value: '3',
            label: '抹角分',
        },
        {
            value: '4',
            label: '抹分',
        },
    ],
    SKUcodeOptions: [
        {
            value: 0,
            label: '不设置',
        },
        {
            value: 1,
            label: '使用原商品ID',
        },
        {
            value: 2,
            label: '使用{来源平台#原商品ID}',
        },

        {
            value: 3,
            label: '原商品编码',
        },
    ],
    colorNotesOptions: [
        {
            value: '0',
            label: '无标记',
        },
        {
            value: '1',
            label: '红色',
        },
        {
            value: '2',
            label: '绿色',
        },
        {
            value: '3',
            label: '蓝色',
        },
        {
            value: '4',
            label: '黄色',
        },
        {
            value: '5',
            label: '紫色',
        },
    ],
    commTypeOptions: [
        {
            value: '1',
            label: '包含',
        },
        {
            value: '2',
            label: '唯一',
        },
    ],
    comStatusCRM: [
        {
            value: 0,
            label: '全部',
        },
        {
            value: 1,
            label: '已上架',
        },
        {
            value: 2,
            label: '已下架',
        },
    ],
    smsType: [
        {
            value: 0,
            label: '会员营销',
        },
        {
            value: 1,
            label: '下单关怀',
        },
        {
            value: 2,
            label: '未付款提醒',
        },
        {
            value: 3,
            label: '付款关怀',
        },
        {
            value: 4,
            label: '付款关怀',
        },
        {
            value: 5,
            label: '延迟发货',
        },
        {
            value: 6,
            label: '发货',
        },
        {
            value: 7,
            label: '确认收货提醒',
        },
        {
            value: 8,
            label: '申请退款',
        },
    ],
    menuData: [
        {
            menuTitle: '开始复制',
            icon: 'el-icon-document-copy',
            path: '/copy/index/',
        },
        {
            menuTitle: '复制记录',
            icon: 'el-icon-document',
            path: '/copy/record/',
        },
    ],
    // 保留小数
    decimalOptions: [
        {
            name: '抹厘',
            id: 0,
        },
        {
            name: '四舍五入取整',
            id: 1,
        },
        {
            name: '向上取整',
            id: 2,
        },
        {
            name: '抹角分',
            id: 3,
        },
        {
            name: '抹分',
            id: 4,
        },
        // {
        //   name: "保留小数",
        //   id: 5,
        // },
    ],
    priceLowestOptions: [
        {
            value: 0,
            label: '加',
        },
        {
            value: 1,
            label: '减',
        },
    ],
    //复制到更多平台
    imgData: [
        {
            imgUrl: 'https://oss.fjdaze.com/oneKeyCopy1688/common/iconiImg/pdd.png',
            openUrl: 'https://fuwu.pinduoduo.com/service-market/service-detail?detailId=5752',
            text: '拼多多·大泽上货',
        },
        {
            imgUrl: 'https://oss.fjdaze.com/oneKeyCopy1688/common/iconiImg/ks.png',
            openUrl: 'https://fuwu.kwaixiaodian.com/detail?id=673760676175',
            text: '快手·大泽上货',
        },
        {
            imgUrl: 'https://oss.fjdaze.com/oneKeyCopy1688/common/iconiImg/ssh.png',
            openUrl: 'https://channels.weixin.qq.com/shop/serviceMarket/index',
            text: '视频号·大泽上货',
        },
    ],
    toolsData: [
        {
            title: '拼多多',
            img: 'http://dazezb.oss-cn-zhangjiakou.aliyuncs.com/oneKeyCopy1688/iconImg/tools/pdd.png',
            link: 'https://mms.pinduoduo.com/login/',
            children: [
                {
                    name: '大泽上货助手',
                    url: 'https://fuwu.pinduoduo.com/service-market/service-detail?detailId=5752',
                },
                {
                    name: '大泽店长工具',
                    url: 'https://fuwu.pinduoduo.com/service-market/service-detail?detailId=34598',
                },
                {
                    name: '大泽云一键下单',
                    url: 'https://fuwu.pinduoduo.com/service-market/service-detail?detailId=37884',
                },
            ],
        },
        {
            title: '快手',
            img: 'http://dazezb.oss-cn-zhangjiakou.aliyuncs.com/oneKeyCopy1688/iconImg/tools/ks.png',
            link: 'https://s.kwaixiaodian.com/',
            children: [
                {
                    name: '大泽上货助手',
                    url: 'https://fuwu.kwaixiaodian.com/detail?id=673760676175',
                },
            ],
        },
        {
            title: '抖音',
            img: 'http://dazezb.oss-cn-zhangjiakou.aliyuncs.com/oneKeyCopy1688/iconImg/tools/dy.png',
            link: 'https://fxg.jinritemai.com/login/common',
            children: [
                {
                    name: '大泽上货助手',
                    url: 'https://fuwu.jinritemai.com/detail?btm_ppre=a0254.b7465.c55193&btm_pre=a0254.b9825.c7579.d6976_1&page_from=1hdnahlef_b9825&pre_show_id=fc7d9e25-27d7-48f9-b08f-0c3ebf287fa3&searchKey=%E5%A4%A7%E6%B3%BD&service_id=97',
                },
                {
                    name: '大泽快递打印',
                    url: 'https://fuwu.jinritemai.com/detail?btm_ppre=a0254.b7465.c55193&btm_pre=a0254.b9825.c7579.d6976_0&page_from=1hdnahlef_b9825&pre_show_id=fc7d9e25-27d7-48f9-b08f-0c3ebf287fa3&searchKey=%E5%A4%A7%E6%B3%BD&service_id=285',
                },
            ],
        },
        {
            title: '小红书',
            img: 'http://dazezb.oss-cn-zhangjiakou.aliyuncs.com/oneKeyCopy1688/iconImg/tools/xhs.png',
            link: 'https://customer.xiaohongshu.com/login?service=https://ark.xiaohongshu.com/',
            children: [
                {
                    name: '大泽上货助手',
                    url: 'https://fuwu.xiaohongshu.com/applicationDetail?appId=5ff2982e3c274bcd8a42',
                },
            ],
        },
        {
            title: '微信视频号',
            img: 'http://dazezb.oss-cn-zhangjiakou.aliyuncs.com/oneKeyCopy1688/iconImg/tools/sph.png',
            link: 'https://channels.weixin.qq.com/shop',
            children: [
                {
                    name: '大泽上货助手 (找到“服务市场”搜索“大泽”)',
                    url: 'https://channels.weixin.qq.com/shop',
                },
            ],
        },
    ],
    //菩提更多平台工具
    putiToolsData: [
        {
            title: '拼多多',
            img: 'http://dazezb.oss-cn-zhangjiakou.aliyuncs.com/oneKeyCopy1688/iconImg/tools/pdd.png',
            link: 'https://mms.pinduoduo.com/login/',
            children: [
                {
                    name: '菩提上货助手',
                    url: 'https://fuwu.pinduoduo.com/service-market/service-detail?detailId=77393',
                },
            ],
        },
        {
            title: '快手',
            img: 'http://dazezb.oss-cn-zhangjiakou.aliyuncs.com/oneKeyCopy1688/iconImg/tools/ks.png',
            link: 'https://s.kwaixiaodian.com/',
            children: [
                {
                    name: '菩提上货助手',
                    url: 'https://fuwu.kwaixiaodian.com/detail?id=20707357955159',
                },
            ],
        },
        {
            title: '抖音',
            img: 'http://dazezb.oss-cn-zhangjiakou.aliyuncs.com/oneKeyCopy1688/iconImg/tools/dy.png',
            link: 'https://fxg.jinritemai.com/login/common',
            children: [
                {
                    name: '菩提上货',
                    url: 'https://fuwu.jinritemai.com/detail?service_id=25314',
                },
            ],
        },
    ],
};
